import React from 'react'
import { Grid, Typography } from '@mui/material'
import oneHundredBlackMen from '../Media/images/100-BM-New-Logo-k-871-®.png'
import kappaAplhaPsi from '../Media/images/download.jfif'
import openArms from '../Media/images/Open Arms Logo.png'
import striveToThrive from '../Media/images/Picture3.png'
import strongerTogether from '../Media/images/ASU Stronger Together.png'
import albanyStateLogo from '../Media/images/albany-state-logo.png'
import PartnershipCard from '../Components/PartnershipCard'

export default function Partnerships() {

    return (
        <Grid container display='flex' direction='row' justifyContent='center' sx={{backgroundColor:'#181824', pt:5, mb:8, height:{xs:'100%', md:'100vh'}}}>
            <Grid item container justifyContent='center'>
                <Typography variant='h5' color='#FFF' fontSize={25} fontWeight='bold' sx={{py:2}}>PARTNERSHIPS</Typography>
            </Grid>
            <Grid container justifyContent='center' color='#36BAFE' direction='row' columnSpacing={4} rowSpacing={4} sx={{width: '100%', color:'#36BAFE'}}>
                <PartnershipCard src={oneHundredBlackMen} orgName={'100 BLACK MEN of AMERICA, INC®'} link={'https://100blackmen.org/'}/>
                <PartnershipCard src={kappaAplhaPsi} orgName={'KAPPA ALPHA PSI FRATERNITY, INC®'} link={'https://www.kappaalphapsi1911.com/'}/>
                <PartnershipCard src={openArms} orgName={'Open Arms, INC®'} link={'https://openarmsinc.org/'}/>
                <PartnershipCard src={striveToThrive} orgName={'Strive 2 Thrive'} link={''}/>
                <PartnershipCard src={strongerTogether} orgName={'Stronger Together'} link={''}/>
                <PartnershipCard src={albanyStateLogo} orgName={'Albany State University'} link={'https://www.asurams.edu/index.php'}/>
            </Grid>  
        </Grid>
    )
}
